import { validationMessages } from '../../translations'

export const required = (value, formatMessage = undefined) => {
  const error = (formatMessage && formatMessage(validationMessages.required)) || 'Required'
  if (!value) return error
  if (typeof value === 'string' && value?.trim() === '') return error
  if (value === true) return null
  if (typeof value === 'object') return null
}
